module.exports = __webpack_public_path__ + "884c932d47a43e6e948a432b19cb6ebf.pdf";